import React, { useEffect, useRef } from "react";
import analytics from "modules/analytics";
import PropTypes from "prop-types";
import { PAGES } from "../lib/constants";
import { Actions } from "../reducers";
import styles from "./modal.scss";

const Modal = (props) => {
  const { termsContent, staticData, page } = props;
  const { title, scrollMessage, loginHeader } = staticData.modal;
  let header = null;
  const modalRef = useRef(null);

  // Focus trap
  useEffect(() => {
    const modalContent = document.querySelector("#terms-modal-content"); // selectable modal content
    const modalFooter = document.querySelector("#modal-footer"); // clost button
    const focusableElements = "button, [href]";

    const firstFocusableElement =
      modalContent.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
    const focusableContent = [
      ...modalContent.querySelectorAll(focusableElements),
      ...modalFooter.querySelectorAll(focusableElements),
    ];
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
    const eventHandler = (e) => {
      let isTabPressed = e.key === "Tab";

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus(); // add focus for the last focusable element
          e.preventDefault();
        }
      } else {
        // if tab key is pressed
        if (document.activeElement === lastFocusableElement) {
          // if focused has reached to last focusable element then focus first focusable element after pressing tab
          firstFocusableElement.focus(); // add focus for the first focusable element
          e.preventDefault();
        }
      }
    };
    if (modalRef.current) {
      document.addEventListener("keydown", eventHandler);
    }
    // focus trap end
    return () => {
      document.removeEventListener("keydown", eventHandler);
    };
  }, [modalRef]);

  const closeTermsModal = (e) => {
    e.preventDefault();
    analytics.sendEvent("ui-behavior", "accepted", "terms-modal");
    props.dispatch(Actions.termsClose());
  };

  const preventTouch = (e) => {
    e.preventDefault();
  };

  if (page === PAGES.LOGIN) {
    header = loginHeader;
  } else {
    if (page === PAGES.SIGNUP) {
      header = title;
    }
  }

  return (
    <div>
      <div
        id="terms-modal"
        className="modal-backdrop fade in"
        onTouchStart={preventTouch}
        ref={modalRef}
      ></div>
      <div className={`modal fade in ${styles.modal}`}>
        <div className="modal-header">
          <h3>{header}</h3>
        </div>
        <div className={styles.body}>
          <span
            id="terms-modal-scroll-message"
            dangerouslySetInnerHTML={{ __html: scrollMessage }}
          />
          <div id="terms-modal-content" className={styles.content}>
            <div dangerouslySetInnerHTML={{ __html: termsContent }} />
          </div>
        </div>
        <div className={`modal-footer ${styles.modalFooter}`} id="modal-footer">
          <button
            id="terms-modal-agree"
            className={"btn btn-normal pull-left"}
            onClick={closeTermsModal}
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  termsContent: PropTypes.string,
  staticData: PropTypes.object.isRequired,
  page: PropTypes.string.isRequired,
};

export default Modal;
